import React from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Normalize the 3 differing backend pagination shapes into one:
//  - Dashboard:        { page, totalPages, total }
//  - Analytics/Member: { page, limit, total, totalPages, hasNext, hasPrev }
//  - Subhadra:         { currentPage, itemsPerPage, totalItems, totalPages, hasNext, hasPrev }
export function normalizePagination(raw = {}) {
  const page = raw.page ?? raw.currentPage ?? 1;
  const limit = raw.limit ?? raw.itemsPerPage ?? null;
  const total = raw.total ?? raw.totalItems ?? 0;
  const totalPages = raw.totalPages ?? (limit ? Math.max(1, Math.ceil(total / limit)) : 1);
  const hasPrev = raw.hasPrev ?? page > 1;
  const hasNext = raw.hasNext ?? page < totalPages;
  return { page, limit, total, totalPages, hasPrev, hasNext };
}

// Props: pagination (normalized), onPageChange(page), pageSize, onPageSizeChange,
//        showPageSize, unitLabel, shown (rows currently shown).
export default function Pagination({
  pagination,
  onPageChange,
  pageSize,
  onPageSizeChange,
  showPageSize = true,
  unitLabel = 'records',
  shown,
}) {
  const { page, total, totalPages, hasPrev, hasNext } = pagination;
  if (!total) return null;

  return (
    <div className="pagination-bar">
      <div className="pagination-info">
        {shown != null ? `Showing ${shown} of ${total} ${unitLabel}` : `${total} ${unitLabel}`}
      </div>
      <div className="pagination-controls">
        <button className="page-btn" onClick={() => onPageChange(page - 1)} disabled={!hasPrev}>
          <ChevronLeftIcon fontSize="small" /> Prev
        </button>
        <span className="pagination-info">Page {page} of {totalPages}</span>
        <button className="page-btn" onClick={() => onPageChange(page + 1)} disabled={!hasNext}>
          Next <ChevronRightIcon fontSize="small" />
        </button>
      </div>
      {showPageSize && onPageSizeChange ? (
        <select
          className="page-size-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          <option value={10}>10 / page</option>
          <option value={20}>20 / page</option>
          <option value={50}>50 / page</option>
          <option value={100}>100 / page</option>
        </select>
      ) : null}
    </div>
  );
}
